import { service } from '@ember/service';

import type { RecordData, Service } from 'webapp-types';
import { ModelName } from 'webapp/enums/enums';
import { getRelativeTime } from 'webapp/utils/number';

import BufferedModel from 'webapp/models-custom/buffer/buffered-model';
import type Report from 'webapp/models-custom/report';
import type ReportScheduleSetting from 'webapp/models-custom/report-schedule-setting';
// import type UserRecord from 'webapp/models/user';
import type ReportScheduleRecord from 'webapp/models/report-schedule';

import { Severity } from 'webapp/services/logger';

export const Status = {
	READY: 1,
	WAITING: 2,
	SKIPPED: 3,
};

export default class ReportSchedule extends BufferedModel<
	ReportScheduleRecord,
	RecordData.ReportSchedule.Serialized
> {
	@service('logger') declare loggerService: Service.Logger;
	@service('timer') declare timerService: Service.Timer;
	@service('model-manager/report-schedule-settings')
	declare mmReportScheduleSettingsService: Service.ModelManager.ReportScheduleSettings;

	// ------- props from / to ED record ------

	get id(): string | null {
		return this.model.id;
	}

	get reportScheduleSettingId(): number {
		return this.getBuffered('reportScheduleSettingId');
	}

	get scheduledOn(): number {
		return this.getBuffered('scheduledOn');
	}

	// get approvedBy(): number[] {
	// 	return this.getBuffered('approvedBy');
	// }

	// get skippedBy(): number | null {
	// 	return this.getBuffered('skippedBy');
	// }

	get reportUrl(): string {
		// only for "generate now, send later" case
		return this.model.reportUrl;
	}

	// ------- other props ------

	get reportScheduleSetting(): ReportScheduleSetting | null {
		let report;
		if (this.reportScheduleSettingId) {
			report = this.mmReportScheduleSettingsService.findModel(
				String(this.reportScheduleSettingId),
			);
			if (!report) {
				this.loggerService.logError(
					'Missing report schedule setting for report schedule',
					{
						reportScheduleId: this.id,
						reportScheduleSettingId: this.reportScheduleSettingId,
					},
					Severity.WARNING,
				);
			}
		}
		return report || null;
	}

	get report(): Report | null {
		return this.reportScheduleSetting?.report || null;
	}

	get isOneOff(): boolean {
		const reportScheduleSetting = this.reportScheduleSetting;
		return !reportScheduleSetting || reportScheduleSetting.isOneOff;
	}

	get isReportUrlGenerating(): boolean {
		return this.isOneOff && !this.reportUrl;
	}

	// get skippedByUser(): UserRecord | null {
	// 	let user;
	// 	if (this.skippedBy) {
	// 		user = this.mmUsersService.findRecord(String(this.skippedBy));
	// 		if (!user) {
	// 			this.loggerService.logError('Missing skipped by user for report schedule', {
	// 				reportScheduleId: this.id,
	// 				userId: this.skippedBy
	// 			}, Severity.WARNING);
	// 		}
	// 	}
	// 	return user || null;
	// }

	// get isApprovalRequired(): boolean {
	// 	return !!this.reportScheduleSetting?.approvalRequired;
	// }

	// get isApproved(): boolean {
	// 	return this.approvedBy.length > 0;
	// }

	// get isMissingApproval(): boolean {
	// 	return this.isApprovalRequired
	// 		&& !this.isApproved;
	// }

	// get isMissingMyApproval(): boolean {
	// 	return this.isMissingApproval
	// 		&& !!this.reportScheduleSetting?.needsMyApprovalToSend;
	// }

	// get isSkipped(): boolean {
	// 	return !!this.skippedBy;
	// }

	get isReadyToBeSent(): boolean {
		return !this.isOneOff;
		// return this.sendStatus === Status.READY;
	}

	// get sendStatus(): number {
	// 	if (this.isSkipped) {
	// 		return Status.SKIPPED;
	// 	} else if (this.isMissingApproval) {
	// 		return Status.WAITING;
	// 	} else {
	// 		return Status.READY;
	// 	}
	// }

	get sendStatusText(): string {
		let text = this.isReadyToBeSent ? 'Sending' : 'Scheduled';
		if (this.timeLeft <= 60) {
			text += ' <span> soon</span>';
		} else {
			text += ` <span> ${getRelativeTime(this.scheduledOn)}</span>`;
		}
		return text;
	}

	get timeLeft(): number {
		return this.scheduledOn - this.timerService.currentTs;
	}

	// get canSkip(): boolean {
	// 	const reportScheduleSetting = this.reportScheduleSetting;
	// 	return !!reportScheduleSetting
	// 		&& (   reportScheduleSetting.isMine
	// 			|| reportScheduleSetting.needsMyApprovalToSend
	// 		);
	// }

	static override modelName = ModelName.REPORT_SCHEDULE; // store record type
}
